// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellTestCard-cls1__ln","cls2":"UpsellTestCard-cls2_HCc UpsellTestCard-cls1__ln"};